import React from 'react'
import classNames from "classnames/bind";
import styles from "./Chip.module.scss";

export interface ChipParams {
  variant: string | "success" | "info" | "warning" | "error" | "light" | "info2";
  type: "fill" | "dot" | "outlined";
  dot?: boolean;
  children: any
}



export default function Chip({ variant, type , children, dot}: ChipParams) {
  let cx = classNames.bind(styles);
  let chipClassNames = cx({
    chip: true,
    fill: type === "fill",
    dot: type === "dot" || dot,
    outlined: type === "outlined",
    success: variant === "success",
    info: variant === "info",
    info2: variant === "info2",
    warning: variant === "warning",
    error: variant === "error",
    light: variant === "light",
  });

  return <div className={chipClassNames}>{children}</div>;
}
